import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const TwitterCircle24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      className={cn(
        chroma === 'default' && s.twitterFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M12.5 1C18.847 1 24 6.153 24 12.5S18.847 24 12.5 24 1 18.847 1 12.5 6.153 1 12.5 1zm2.312 6.9c-1.223 0-2.243 1.026-2.243 2.315 0 .175.029.351.058.527-1.864-.088-3.496-1.025-4.603-2.403-.204.352-.291.733-.291 1.172 0 .792.407 1.495.99 1.934-.378 0-.699-.117-1.02-.293v.03c0 1.113.758 2.05 1.807 2.256a1.874 1.874 0 01-.583.087c-.145 0-.291 0-.408-.029.292.908 1.107 1.582 2.098 1.612a4.384 4.384 0 01-2.768.996c-.174 0-.35 0-.524-.03a6.248 6.248 0 003.438 1.026c4.108 0 6.38-3.516 6.38-6.563v-.293a4.349 4.349 0 001.107-1.201c-.408.175-.845.322-1.282.351.379-.351.728-.79.903-1.318-.437.263-.903.469-1.427.557a2.24 2.24 0 00-1.632-.733z"
      fillRule="evenodd"
    />
  </svg>
);

export default TwitterCircle24;
